export const LESSON_TYPE = {
  GAME: "game",
  TASK: "task",
};
